module.exports = __webpack_public_path__ + "img/horse-ride.5a6b0883.svg";